import { NgModule } from '@angular/core';
import { NotificationsListPageComponent } from './notifications-list-page/notifications-list-page.component';
import { NotificationsListIframeComponent } from './notifications-list-iframe/notifications-list-iframe.component';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';
import { UserwaySyncModule } from '../shared/userway-sync.directive';

@NgModule({
    imports: [SafeUrlPipeModule, UserwaySyncModule],
    exports: [NotificationsListPageComponent],
    declarations: [NotificationsListPageComponent, NotificationsListIframeComponent],
    providers: [],
})
export class NotificationsListModule { }



// WEBPACK FOOTER //
// ./ts/app/notifications-list/notifications-list.module.ts